<template>
  <div id="app" ref="grcapp">
    <resize-observer @notify="MainResizeEvent" />

    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcDialog2 ref="Dialog2"></GrcDialog2>
    <GrcDialog_CookieConsent ref="Dialog_CookieConsent"></GrcDialog_CookieConsent>

    <div :class="['render_cont', IsRenderMounted?'render_cont_done':'']">

      <template v-for="(page) in PAGES">
          <component ref="pagerender" :is="page.Component" :key="page.UniqueID" v-on:render_mounted="OnRenderMounted">
          </component>
      </template>    

    </div>

    <!-- <GrcCMSRENDER ref="CMSRENDER"></GrcCMSRENDER> -->

  </div>

</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';

import RuntimeTemplateCompiler from "vue-runtime-template-compiler"
Vue.use(RuntimeTemplateCompiler)


import GrcDB from './components/GrcComponents/GrcDB.vue'
import GrcDialog from './components/GrcComponents/GrcDialog.vue'
import GrcDialog2 from './components/GrcComponents/GrcDialog2.vue'
import GrcDialog_CookieConsent from './components/GrcComponents/GrcDialog_CookieConsent.vue'
import GrcCMSRENDER from './components/GrcComponents/GrcCMSRENDER.vue'


export default {
  name: 'app',
  components: {
    GrcDB,
    GrcCMSRENDER,
    GrcDialog,
    GrcDialog2,
    GrcDialog_CookieConsent,
  },
    data () {
      return {
        CurrentPath: "",
        LastWindowWidth:0,
        PAGES:[],
        IsRenderMounted:false,

        ConsentManager_CookieName:"",
        GA_TrackingCode:"",
        GA_Prefix:"",
        CM_Settings: { CM_GA:0, CM_HJ:0, CM_FBP:0, CM_TAB:0, CM_TEADS:0 },

      }
  },
  methods: {

    async ShowTextbookItemDialog(pTitle, pFormName, pCompName, pWidth)
    {
      let pText = grcmain_GetTextBookItem(pFormName, pCompName);

      pTitle = "<i class='fal fa-info-circle' style='margin-right:6px;'></i>" + pTitle;
      var params = { title: pTitle, text: pText, color: grccomp_dialog_default_color(), width:pWidth,
          buttons: [{text: "Bezárás", value: "OK", color:"cms_linkbutton_OK", width:"100px", default: true}]
      };

      let DialogResult = "";

      await this.$refs.Dialog2.ShowDialog(params).then(res => 
      { 
          DialogResult = res; 
      });               

      

    },


    SetPageRendered()
    {
      //console.log("render mount: "+Date.now());
      this.IsRenderMounted = true;
    },

    OnRenderMounted()
    {
      setTimeout(this.SetPageRendered ,200);        
    },


    MainResizeEvent()
    {
      var w = grccomp_getScreenSize().width;
      if (w != this.LastWindowWidth)
      {
        //this.CloseTopMenus();
      }

      this.LastWindowWidth = w;
      //console.log("resized: "+w);
    },

    async Logout()
    {
        this.$refs.GRCDB.ShowLoading(false);
       
        var QP = {
          sSessionID: "[APPSESSIONID]",
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_Logout", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            alert(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        document.location = Q.RESULT[0].RedirUrl;



    },


      async Init()
      {
        let RID = "";
        if (GRCAPP_GetParameters.hasOwnProperty("RID"))
        {
          RID = GRCAPP_GetParameters.RID;
        }

        if (RID != "")
        {
          this.$refs.GRCDB.ShowLoading(false);
        
          var QP = {
            sAzonosito: RID,
          };
          var Q;
          await this.$refs.GRCDB.GetData("AppInit_Redir", QP).then(res => { Q = res; });

          if (Q.APPERR[0].ERR != "")
          {
              this.$refs.GRCDB.HideLoading();
              alert(Q.APPERR[0].ERR);
              return;
          }

          gDashboardUgyfelID = Q.RESULT[0].UgyfelID;
        }
        else
        {
          let lsDashboarUgyfelID = localStorage.getItem('DashboardUgyfelID');
          if (lsDashboarUgyfelID == null) { lsDashboarUgyfelID = "0"; }

          gDashboardUgyfelID = parseInt(lsDashboarUgyfelID);
        }

        gXLMS = "";

        if (GRCAPP_BackendParameters.hasOwnProperty("XLMS"))
        {
          gXLMS = GRCAPP_BackendParameters.XLMS;
        }

        let TextbookDate = localStorage.getItem('TextbookDate');
        if (TextbookDate == null) { TextbookDate = ""; }

        this.$refs.GRCDB.ShowLoading(false);
       
        var QP = {
          sSessionID: "[APPSESSIONID]",
          sAlias: GRCAPP_GetParameters.ALIAS,
          sTextbookDate: TextbookDate
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_AppInit", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
          //console.log(Q);
            this.$refs.GRCDB.HideLoading();
            alert(Q.APPERR[0].ERR);
            return;
        }

        //console.log(Q);

        if (Q.RESULT[0].TextbookRefresh == 1)
        {
          localStorage.setItem("TextbookDate", Q.RESULT[0].TextbookMaxDate);
          localStorage.setItem("TextbookContent", JSON.stringify(Q.TEXTBOOK));
        }

        let TextBookContent = localStorage.getItem("TextbookContent");
        if (TextBookContent != "")
        {
          gTextBook = JSON.parse(TextBookContent);
        }

        gPageContent = Q.PAGECONTENT[0].PageContent;
      
        this.$refs.GRCDB.HideLoading();
        
        gAppInitDone = true;


        this.PAGES.push({ Component: GrcCMSRENDER, UniqueID: "0" });

        this.ConsentManager_CookieName = Q.MISC[0].ConsentManager_CookieName;
        this.GA_TrackingCode = Q.MISC[0].GA_TrackingCode;
        this.GA_Prefix = Q.MISC[0].GA_Prefix;
        
        if (this.ConsentManager_CookieName == "") { return; }
        
        if (this.$cookie.get(this.ConsentManager_CookieName) == null)
        {
          this.ShowConsentMan(this.ConsentManager_CookieName);
        }
        else
        {
          this.LoadConsentMan();
        }

      },

      async ShowConsentMan(pCookieName)
      {
          var DialogResult = "";
          var p = grccomp_dialog_alert_GetDefaults("", "");   
          p.title = "";          
          p.height = 450;
          p.width = 500;
          p.padding_top = -1;
          if (grccomp_getScreenSize().width < 500) { p.width = 320; p.height = 500; }
          this.$refs.Dialog_CookieConsent.ShowDialog(p, pCookieName).then(res => 
          { 
              DialogResult = res; 
              this.LoadConsentMan();
          });               
      },

      LoadConsentMan()
      {
        let CM = this.$cookie.get(this.ConsentManager_CookieName);
        if (CM == null) { CM = ""; } else { CM = ","+CM; }
       

        if (CM.includes(",GA,")) { this.CM_Settings.CM_GA = 1; } else { this.CM_Settings.CM_GA = 0; }
        if (CM.includes(",HJ,")) { this.CM_Settings.CM_HJ = 1; } else { this.CM_Settings.CM_HJ = 0; }
        if (CM.includes(",FBP,")) { this.CM_Settings.CM_FBP = 1; } else { this.CM_Settings.CM_FBP = 0; }
        if (CM.includes(",TAB,")) { this.CM_Settings.CM_TAB = 1; } else { this.CM_Settings.CM_TAB = 0; }
        if (CM.includes(",TEADS,")) { this.CM_Settings.CM_TEADS = 1; } else { this.CM_Settings.CM_TEADS = 0; }
        
        if (this.GA_TrackingCode == "") { this.CM_Settings.CM_GA = 0; }

        if (this.CM_Settings.CM_GA == 1)
        { 
          this.$gtag.config({ id: this.GA_TrackingCode });
          
          this.$gtag.optIn(); 

          this.SendTagManagerPageView(GRCAPP_GetParameters.ALIAS);

        } 
        else 
        { 
          this.$gtag.optOut(); 
        }
        
      },



    SendTagManagerEvent(pEventName, pParams)
    {
      //let pParams = { 'event_category':pCategory, 'event_label': pLabel, 'value':pValue };

      if (this.CM_Settings.CM_GA != 1) { return; }
      this.$gtag.event(pEventName, pParams);
    },

    SendTagManagerPageView(pRoute)
    {
      if (this.CM_Settings.CM_GA != 1) { return; }
      this.$gtag.pageview({ page_path: this.GA_Prefix+pRoute })
    },

    PageScrolled(e)
    {
      //console.log(window.scrollY);

      //let H = document.querySelector("html");      
      //H.dataset.scroll = window.scrollY;

    },

    async HandleCommError(pErrorText)
    {

      pErrorText = ""+pErrorText;

      var RightCheckResult = -1000;
      var ErrorText = "";

      if (pErrorText.startsWith("UNKNOWN_ERR"))
      {
        RightCheckResult = -999;
        ErrorText = pErrorText.replace("UNKNOWN_ERR:","");
      }

      
      if (pErrorText.startsWith("COMM_ERROR"))
      {
        RightCheckResult = -998;
        ErrorText = pErrorText.replace("COMM_ERROR:","");
      }

      if (pErrorText.startsWith("RIGHT_ERROR"))
      {
        RightCheckResult = 0;
        ErrorText = pErrorText.replace("RIGHT_ERROR:","");
        //this.NavigateToRoute("noright", true);
        return;
      }

      if (pErrorText.startsWith("FNC_ERROR"))
      {
        RightCheckResult = -1;
        ErrorText = pErrorText.replace("FNC_ERROR:","");

        //this.NavigateToRoute("noright", true);
        return;
      }

      if (pErrorText.startsWith("SESSION_ERROR"))
      {
        RightCheckResult = -2;
        ErrorText = pErrorText.replace("SESSION_ERROR:","");

        document.location = "bejelentkezes";
        return;
      }

      if (pErrorText.startsWith("APPVER_ERROR"))
      {
        RightCheckResult = -3;
        ErrorText = pErrorText.replace("APPVER_ERROR:","");
      }

      if (ErrorText == "") { ErrorText = pErrorText; }

      var arr = [-1000,-999,-998,0,-1];
      if (arr.includes(RightCheckResult))
      {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", ErrorText).then(res => { DialogResult = res; });
        return;
      }

      if (RightCheckResult == -2)
      {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Hiba", "A bejelentkezés elévült!").then(res => { DialogResult = res; });
        
        //this.$refs.RELOGIN.ShowRelogin();
        document.location = "bejelentkezes";

        return;
      }

      if (RightCheckResult == -3)
      {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", "Az alkalmazás verzió elévült, az új verzió letöltése automatikusan megtörténik!").then(res => { DialogResult = res; });

        location.reload(true);
        return;
      }

    },



  },

  created()
  {

},


  mounted()
  {
    this.Init();
    gApp = this;
    //let self = this;

    this.LastWindowWidth = grccomp_getScreenSize().width;

    window.addEventListener('beforeunload', function(ev) {
        
        document.cookie = "XLMS="+gXLMS+"; Secure";

        //console.log("dash: "+gDashboardUgyfelID);
        localStorage.setItem("DashboardUgyfelID", gDashboardUgyfelID);

        /*
        try
        {
          document.removeEventListener('scroll', self.PageScrolled);
        } catch {}
        */
    });


    //document.addEventListener('scroll', self.PageScrolled);

  },

  updated()
  {

  },

  computed: {

  }  

}


</script>

<style scoped>



</style>
